import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiEndpointsService } from "src/app/shared/services/api-endpoints.service";
import { ApiHttpService } from "src/app/shared/services/api-http.service";

@Component({
  selector: "app-menu-items-content",
  templateUrl: "./menu-items-content.component.html",
  styleUrls: ["./menu-items-content.component.scss"],
})
export class MenuItemsContentComponent implements OnInit, OnChanges {
  constructor(
    private router: Router,
    private apiHttpService: ApiHttpService,
    private apiEndpointsService: ApiEndpointsService,
    private activateRoute: ActivatedRoute
  ) {}

  currentMenuItem: any;
  listItems: any;
  companyId: string = "";
  menuItemId: string = "";
  menuItemType: string = "";
  selectedListItem: any;
  questionnaire: any;
  metricData: any;

  ngOnInit(): void {
    this.currentMenuItem = history.state;
    this.companyId = this.activateRoute.snapshot.params["companyId"];
    this.menuItemId = this.activateRoute.snapshot.params["menuItemId"];
    this.menuItemType = this.activateRoute.snapshot.params["menuItemType"];

    this.getListItems(this.companyId, this.menuItemId, this.menuItemType);
  }

  ngOnChanges(changes: SimpleChanges): void {}

  getListItems(companyId: string, menuItemId: string, menuItemType: string) {
    if (menuItemType === "checklist") {
      this.apiHttpService
        .get(this.apiEndpointsService.getCheckListItems(companyId, menuItemId))
        .subscribe(
          (response) => {
            let listItemsResponse = JSON.parse(JSON.stringify(response));
            this.listItems = listItemsResponse.data;
            this.selectedListItem = this.listItems[0];
            if (this.selectedListItem.type === "questionnaire") {
              this.getQuestionnaire(this.companyId, this.selectedListItem.id);
            }
          },
          (error) => {
            console.log("Error: ", error);
          }
        );
    } else if (menuItemType === "metriclist") {
      this.apiHttpService
        .get(this.apiEndpointsService.getMetricListItems(companyId, menuItemId))
        .subscribe(
          (response) => {
            let listItemsResponse = JSON.parse(JSON.stringify(response));
            this.listItems = listItemsResponse.data;
            this.selectedListItem = this.listItems[0];
            if (this.selectedListItem.type === "questionnaire") {
              this.getQuestionnaire(this.companyId, this.selectedListItem.id);
            }

            if (this.selectedListItem.type === "metric") {
              this.getMetricData(this.companyId, this.selectedListItem.id);
            }
          },
          (error) => {
            console.log("Error: ", error);
          }
        );
    }
  }

  onListItemChange(item: any) {
    if (item.id !== this.selectedListItem.id) {
      this.selectedListItem = item;
      this.questionnaire = null;
      this.metricData = null;
      if (item.type === "questionnaire") {
        this.getQuestionnaire(this.companyId, item.id);
      }
      if (item.type === "metric") {
        this.getMetricData(this.companyId, item.id);
      }
    }
  }

  getMetricData(companyId: string, metricId: string) {
    this.apiHttpService
      .get(this.apiEndpointsService.getMetricData(companyId, metricId))
      .subscribe(
        (response) => {
          let metricResponse = JSON.parse(JSON.stringify(response));
          this.metricData = metricResponse.data;
        },
        (error) => {
          console.log("Error: ", error);
        }
      );
  }

  getQuestionnaire(companyId: string, questionnaireId: string) {
    this.apiHttpService
      .get(
        this.apiEndpointsService.getQuestionnaire(companyId, questionnaireId)
      )
      .subscribe(
        (response) => {
          let questionnaireResponse = JSON.parse(JSON.stringify(response));
          this.questionnaire = questionnaireResponse.data;
        },
        (error) => {
          console.log("Error: ", error);
        }
      );
  }
}
